module.exports = __webpack_public_path__ + "e-learning-app/static/img/school3.06ea936.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/ne/school3.png
// module id = iPTg
// module chunks = 1